import { EThemeKey } from '@constants';
import { DefaultTheme } from 'styled-components';

import { defaultTheme, darkTheme, primaryTheme } from './theme';

export const THEMES: Record<EThemeKey, DefaultTheme> = {
  [EThemeKey.DEFAULT]: defaultTheme,
  [EThemeKey.PRIMARY]: primaryTheme,
  [EThemeKey.DARK]: darkTheme
};
